var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconKeyMetrics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.92857 3C3.86345 3 3 3.86345 3 4.92857V19.0714C3 20.1365 3.86345 21 4.92857 21H19.0714C20.1365 21 21 20.1365 21 19.0714V4.92857C21 3.86345 20.1365 3 19.0714 3H4.92857ZM6.85714 6.05357C6.41334 6.05357 6.05357 6.41334 6.05357 6.85714C6.05357 7.30095 6.41334 7.66071 6.85714 7.66071H9.42857C9.87237 7.66071 10.2321 7.30095 10.2321 6.85714C10.2321 6.41334 9.87237 6.05357 9.42857 6.05357H6.85714ZM6.05357 10.0714C6.05357 9.62763 6.41334 9.26786 6.85714 9.26786H12.6429C13.0867 9.26786 13.4464 9.62763 13.4464 10.0714C13.4464 10.5152 13.0867 10.875 12.6429 10.875H6.85714C6.41334 10.875 6.05357 10.5152 6.05357 10.0714ZM18.4747 10.4849C18.7031 10.1043 18.5796 9.61071 18.1992 9.38238C17.8186 9.15403 17.325 9.27744 17.0967 9.65799L13.6442 15.412L9.82726 13.2309C9.46056 13.0213 8.99423 13.1314 8.75996 13.4828L6.18853 17.34C5.94236 17.7092 6.04214 18.2082 6.4114 18.4543C6.78067 18.7005 7.27958 18.6007 7.52575 18.2315L9.68112 14.9984L13.5299 17.1978C13.9094 17.4145 14.3927 17.2883 14.6176 16.9135L18.4747 10.4849Z",
    fill: "#001B53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKeyMetrics);
export default __webpack_public_path__ + "static/media/icon-key-metrics.bf6641ee7a5ea515a4f71038e2ec602d.svg";
export { ForwardRef as ReactComponent };